import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { formatCount, sortByHot } from "@/utils/comic";
import ComicCard from "@/components/comic/ComicCard";
import SkeletonCard from "@/components/comic/SkeletonCard";

export default function PopularRecommend() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 900);
    return () => clearTimeout(timer);
  }, []);

  const ranked = sortByHot(comics).slice(0, 8);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门漫画推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">根据浏览与人气数据精选的双女主高分作品</p>
        </div>
        <Link
          to="/category?sort=hot"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          人气榜单 <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      ) : ranked.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center text-sm text-foreground-500">
          暂无推荐内容
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4" data-product-shop>
          {ranked.map((comic, i) => (
            <div key={comic.id} className="relative">
              <span className="absolute -left-1 -top-1 z-10 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-background-50 shadow">
                {i + 1}
              </span>
              <ComicCard comic={comic} />
              <p className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line" /> {formatCount(comic.views)} 人在追
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}